import React from 'react';
import { withStyles } from '@mui/styles';

import Node from '../../common/Node';
import LoaderNew from '../../common/LoaderNew';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import DeletedNodeAlert from '../../common/DeletedNodeAlert';

import { getUrlParameter } from '../../utils';

import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import ActionConfirmation from '../../common/ActionConfirmation';

const styles = {
  paper: {
    display: 'flex',
    background: '#fff',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.03)',
    position: 'relative',
    '&:hover': {
      '& .node-page-edit-btn': {
        display: 'flex',
      },
    },
  },
  frmControlLabel: {
    '& .MuiFormControlLabel-label.Mui-disabled': {
      color: '#878787',
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: '#878787',
    },
  },
  paperTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paperTitle: {
    color: '#4E4C4C',
    fontSize: '16px',
  },
  paperTitleNumber: {
    color: '#4E4C4C',
    fontSize: '30px',
  },
  paperOptions: {
    display: 'flex',
    padding: '0px 20px',
    alignItems: 'center',
  },
  individualsAlert: {
    background: '#FBFBFB',
    padding: '10px 20px',
    color: '#FF0000',
  },
  w185: {
    width: '185px',
    boxSizing: 'border-box',
  },
  ...CommonStyles,
};

class NodePage extends ComponentWrapper {
  state = {
    nodeId: null,
    loaded: false,
    isa: [],
    ako_subs: [],
    ako_supers: [],
    nodes: {},
    descr_individ: '',
    descr_concept: '',
    node: {
      id: 0,
      title: 'No title',
    },
    newImplModal: {
      isOpened: false,
      type: 'isa',
    },
    deleteFrmData: {
      trpls: 'del_ind_and_trpls',
      individuals: 'del_concept',
      rstAndTrpls: 'del_rstrs_and_trpls',
    },
    total_trpls_count: 0,
    isDeletingFinished: true,
    isDeleteModalOpened: false,
    isDeleted: false,
  };

  componentDidMount() {
    document.title="Delete node | Milkyweb";

    const nodeId = getUrlParameter('id');

    this.get({
      url: `/get_node?id=${nodeId}`,
      cb: (res) => {
        let total_trpls_count = 0;

        this.get({
          url: `/get_trpls?cid=${nodeId}`,
          cb: (data) => {
            Object.keys(data.trpls).forEach((rstId) => {
              const count = Array.isArray(data.trpls[rstId]) ? data.trpls[rstId].length : 1;
              total_trpls_count += count;
            });

            const deleteFrmData = {
              trpls: 'del_ind_and_trpls',
              individuals: '',
              rstAndTrpls: '',
            };

            if (res.data.node.is_concept) {
              deleteFrmData.individuals = 'del_concept';
              deleteFrmData.rstAndTrpls = 'del_rstrs_and_trpls';
            }

            if (!res.data.node.is_individ) deleteFrmData.trpls = '';

            this.setState({
              nodeId,
              loaded: true,
              deleteFrmData,
              total_trpls_count,
              isa: res.data.isa,
              node: res.data.node,
              nodes: res.data.nodes,
              ako_subs: res.data.ako_subs,
              ako_supers: res.data.ako_supers,
              descr_individ: res.descr_individ || '',
              descr_concept: res.descr_concept || '',
              inds_explicit_number: res.data.inds_explicit_number,
              inds_implicit_number: res.data.inds_implicit_number,
              restrictions_number: res.data.restrictions_number,
              trpls_count: Object.keys(res.data.trpls).length,
            });
          },
        });
      },
    });
  }

  toggleNewImplModal = (newImplModal) => {
    if (!newImplModal.isOpened) {
      const { node } = this.state;

      this.get({
        url: `/get_node?id=${node.id}`,
        cb: (res) => {
          this.setState({
            nodes: res.data.nodes,
            node: res.data.node,
            ako_subs: res.data.ako_subs,
            ako_supers: res.data.ako_supers,
            inds_explicit_number: res.data.inds_explicit_number,
            inds_implicit_number: res.data.inds_implicit_number,
            restrictions_number: res.data.restrictions_number,
            isa: res.data.isa,
            newImplModal,
          });
        },
      });
    } else {
      this.setState({ newImplModal });
    }
  };

  onRadioBtnChange = (key, value) => {
    const { deleteFrmData } = this.state;

    deleteFrmData[key] = value;

    this.setState({ deleteFrmData });
  };

  onDeleteNodeClick = () => {
    const { node, deleteFrmData } = this.state;

    this.setState({ isDeletingFinished: false }, () => {
      this.postWithData({
        url: `/rest/delete_node`,
        data: {
          id: node.id,
          delete_concept_and_inds: deleteFrmData.individuals === 'del_concept_and_ind',
          delete_inds: deleteFrmData.individuals === 'delete_inds',
        },
        cb: () => {
          this.setState({
            isDeleted: true,
            isDeletingFinished: true,
            isDeleteModalOpened: false,
          });
        },
      });
    });
  };

  render() {
    const { classes } = this.props;
    const {
      node,
      nodes,
      loaded,
      isDeleted,
      trpls_count,
      deleteFrmData,
      total_trpls_count,
      isDeletingFinished,
      isDeleteModalOpened,
      restrictions_number,
      inds_implicit_number,
    } = this.state;

    return (
      <div style={{ paddingBottom: '20px' }}>
        <ActionConfirmation
          modalData={{
            open: isDeleteModalOpened,
            contentText: "Delete Node",
            contentBoldText: `#${node.id} ${node.title}?`,
          }}
          acceptHandler={this.onDeleteNodeClick}
          onClose={() => this.setState({ isDeleteModalOpened: false })}
        />

        <div className={`${classes.subHead} ${classes.mb20}`}>Add tag</div>

        {isDeleted ? (
          <DeletedNodeAlert node={node} />
        ) : !loaded ? (
          <div className={`${classes.justifyCenter} ${classes.pt50}`}>
            <LoaderNew />
          </div>
        ) : (
          <div>
            <div className={classes.justifyCenter}>
              <Node
                isLink
                size="big"
                node={node}
                nodes={nodes}
                nodeId={node.id}
                style={{
                  marginRight: '55px',
                }}
              />
              <div style={{ width: '553px' }}>
                <div className={`${classes.paper} ${classes.mb20} ${!node.is_individ ? classes.op5 : ''}`}>
                  <div className={`${classes.paperTitleContainer} ${classes.w185} ${classes.p20}`}>
                    <span className={classes.paperTitle}>Triples</span>
                    <span className={classes.paperTitleNumber}>{trpls_count}</span>
                  </div>
                  <div className={classes.paperOptions}>
                    <RadioGroup value={deleteFrmData.trpls}>
                      <FormControlLabel
                        className={classes.frmControlLabel}
                        value="del_ind_and_trpls"
                        control={
                          <Radio
                            disabled
                            color="default"
                            onChange={(e) => this.onRadioBtnChange('trpls', 'del_ind_and_trpls')}
                          />
                        }
                        label="Delete individual and triples"
                      />
                    </RadioGroup>
                  </div>
                </div>

                <div
                  className={`${classes.paper} ${!node.is_concept ? classes.op5 : ''} ${classes.mb20}`}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <div className={`${classes.paperTitleContainer} ${classes.w185}  ${classes.p20}`}>
                      <span className={classes.paperTitle}>Individuals</span>
                      <span className={classes.paperTitleNumber}>{inds_implicit_number}</span>
                    </div>

                    <div className={classes.paperOptions}>
                      <RadioGroup
                        className={classes.group}
                        value={deleteFrmData.individuals}
                        onChange={(e) => console.log(e.target.value)}
                      >
                        <FormControlLabel
                          className={classes.frmControlLabel}
                          value="del_concept"
                          control={
                            <Radio
                              color="default"
                              disabled={node.is_individ && !node.is_concept}
                              onChange={(e) => this.onRadioBtnChange('individuals', e.target.value)}
                            />
                          }
                          label="Delete concept"
                        />

                        <FormControlLabel
                          className={classes.frmControlLabel}
                          value="del_concept_and_ind"
                          control={
                            <Radio
                              color="default"
                              disabled={node.is_individ && !node.is_concept}
                              onChange={(e) => this.onRadioBtnChange('individuals', e.target.value)}
                            />
                          }
                          label="Delete concept and individuals"
                        />

                        <FormControlLabel
                          className={classes.frmControlLabel}
                          value="delete_inds"
                          control={
                            <Radio
                              color="default"
                              disabled={node.is_individ && !node.is_concept}
                              onChange={(e) => this.onRadioBtnChange('individuals', e.target.value)}
                            />
                          }
                          label="Delete individuals"
                        />
                      </RadioGroup>
                    </div>
                  </div>

                  {inds_implicit_number ? (
                    <div className={classes.individualsAlert}>
                      Unsafe operation. Do not continue if you not aware of what exactly you are doing. For more
                      information, contact tech support.
                    </div>
                  ) : null}
                </div>

                <div className={`${classes.paper} ${classes.mb20} ${!node.is_concept ? classes.op5 : ''}`}>
                  <div className={`${classes.w185} ${classes.p20}`}>
                    <div className={`${classes.paperTitleContainer} ${classes.mb20}`}>
                      <span className={classes.paperTitle}>Restrictions</span>
                      <span className={classes.paperTitleNumber}>{restrictions_number}</span>
                    </div>

                    <div className={classes.paperTitleContainer}>
                      <span className={classes.paperTitle}>Total triples</span>
                      <span className={classes.paperTitleNumber}>{total_trpls_count}</span>
                    </div>
                  </div>

                  <div className={classes.paperOptions}>
                    <RadioGroup
                      value={deleteFrmData.rstAndTrpls}
                      className={classes.group}
                      onChange={(e) => console.log(e.target.value)}
                    >
                      <FormControlLabel
                        className={classes.frmControlLabel}
                        value="del_rstrs_and_trpls"
                        control={
                          <Radio
                            disabled
                            color="default"
                            onChange={(e) => this.onRadioBtnChange('rstAndTrpls', 'del_rstrs_and_trpls')}
                          />
                        }
                        label="Delete restrictions and triples "
                      />
                    </RadioGroup>
                  </div>
                </div>

                <div className={classes.justifyEnd}>
                  <div className={classes.alignCenter}>
                    {!isDeletingFinished ? <LoaderNew /> : null}
                    <Button
                      size="small"
                      onClick={() => {
                        this.setState({ isDeleteModalOpened: true });
                      }}
                      className={`${classes.btnBig} ${classes.ml10} ${classes.btnBigNormal}`}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(NodePage);
